<script lang="ts">
  import { differenceInDays } from "$app/utils"
  import Goal from "./MyProgress/Goal.svelte"
  import Task from "./MyProgress/Task.svelte"
  import _ from "lodash"
  import { Lock } from "lucide-svelte"
  import { appStore } from "$app/store.svelte"

  interface Props {
    goalData: {
      goals: any[]
      tasks: any[]
      goal_progresses_dates: any
      task_progresses_dates: any
    }
  }

  let props = $props()
  let { goalData }: Props = props

  const current_user = appStore.current_user

  let freePlan: boolean = appStore.subscription.subscription_type == "free"

  function convertDate(str: string): Date | null {
    if (!str) {
      return null
    } else {
      return new Date(`${str}T00:00:00`)
    }
  }

  appStore.goals = goalData.goals.map((g) => {
    return {
      ...g,
      days_left: differenceInDays(g.expected_at, "today"),
      open_progress: false,
      progress_date: convertDate(goalData.goal_progresses_dates[g.id])
    }
  })

  appStore.tasks = goalData.tasks.map((t) => {
    return {
      ...t,
      days_left: differenceInDays(t.expected_at, "today"),
      open_progress: false,
      progress_date: convertDate(goalData.task_progresses_dates[t.id])
    }
  })

  function updateGoal(goal: GoalType): void {
    let sGoals = appStore.goals
    const index = sGoals.findIndex((g) => g.id === goal.id)
    const prevGoal = sGoals[index]
    const newGoal = { ...prevGoal, ...goal }
    sGoals[index] = newGoal
    appStore.goals = sGoals
  }

  function updateTask(task: TaskType): void {
    let sTasks = appStore.tasks
    const index = sTasks.findIndex((t) => t.id === task.id)
    const prevTask = sTasks[index]
    const newTask = { ...prevTask, ...task }
    sTasks[index] = newTask
    appStore.tasks = sTasks
  }
</script>

<h2 class="text-2xl mt-8 mb-4 text-left flex items-center">
  Goals & Tasks Assigned to Your Departments
  {#if freePlan}
    <Lock class="size-5 text-gray-300 ml-1" />
  {/if}
</h2>

{#if freePlan}
  <div
    class="max-w-3xl mt-8 text-left p-4 border border-yellow-200 bg-yellow-50 text-yellow-800 rounded-lg"
  >
    <Lock class="size-6 text-yellow-700 inline" />
    The <span class="italic">My Progress</span> page is not available on the
    free plan.
    <a
      href={`/plans/${appStore.plan.id}/admin`}
      class="font-bold hover:underline hover:text-blue-600"
      >Please upgrade to a Standard Subscription</a
    > to view Goals and Tasks assigned to your departments along with your personal
    tasks.
  </div>
{:else}
  <div class="goals">
    {#each _.sortBy(appStore.goals, "assignee_name") as goal}
      <Goal {goal} />
    {:else}
      <div
        class="w-full text-center p-4 border border-gray-200 bg-gray-50 font-bold"
      >
        You have no goals assigned to your departments
      </div>
    {/each}
  </div>

  <h2 class="text-2xl mt-6 mb-4 text-left">Tasks Assigned to You</h2>

  <div class="tasks mt-4">
    {#each appStore.tasks.filter((t) => t.assignee_id === current_user.id) as task}
      <Task {task} onupdate={(data) => updateTask(data)} />
    {:else}
      <div
        class="w-full text-center p-4 border border-gray-200 bg-gray-50 font-bold"
      >
        You have no tasks assigned to you.
      </div>
    {/each}
  </div>
{/if}
